import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefreshBlack16 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.1667 5.5L11.5705 4.49981C10.6631 3.57424 9.3986 3 8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13C10.419 13 12.4367 11.2822 12.9 9",
		stroke: "black",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9 6H13V2",
		stroke: "black",
		strokeWidth: 2
	})]
});
export default SvgRefreshBlack16;
